import React, { useEffect, useCallback, useState } from 'react';
import { 
    Box, 
    Paper, 
    Typography, 
    IconButton, 
    Popover, 
    Button,
    Grid
} from '@mui/material';
import TableComponent from '../../../common/table/Table';
import AxiosInstance from '../../../../server/AxioInstance';
import { 
    DownloadingIcon, 
    UpdateFileIcon, 
    PublishIcon 
} from '../../../../shared/components/icon';
import { useDownload, useDialog, useSnackbar } from '../../../../shared/context';
import AlertDialogSlide from '../../../Dialog/EditeDocumentDialog';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

const columns = [
    { id: "document_number", label: "ID Documento", align: 'center'},
    { id: "title", label: "Título", align: 'center' },
    { id: "originalname", label: "Nome do arquivo", align: 'center' },
    { id: "download", label: "Download", align: 'center' },
    { id: "editar", label: "Revisar Documento", align: 'center' },
    { id: "revision", label: "Revisão", align: 'left' },
    { id: "upload", label: "Upload", align: 'center'}
];

const BodyValidationDocument = () => {
    const { handleDownload } = useDownload();
    const [rows, setRows] = useState([]);
    const { showSnackbar } = useSnackbar();
    const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog('editDialog');
    const formData = {
        fileDoc: null,
        filePdf: null,
    };
    
    const handleFileChangeDocs = (event,) => {

        const file = event.target.files[0];
        updateFileDoc(file);

        // const documentoUpload = event.target.files[0].name.split('.');
        // const documentoReview = item.originalname.split('.');
        
        // if(documentoUpload[0] === documentoReview[0]){
        //     const file = event.target.files[0];
        //     updateFileDoc(file);
        // } else {
        //     showSnackbar({
        //         vertical: 'top',
        //         horizontal: 'right',
        //         message: 'Documentos diferentes. Por favor, selecione o mesmo documento.',
        //         variant: 'error',
        //     });
        // }
    };

    const handleFileChangePdf = (event) => {
        const file = event.target.files[0];
        updateFilePdf(file);
        // if(event.target.files[0].name === item.originalname){
        //     const file = event.target.files[0];
        //     updateFilePdf(file);
        // } else {
        //     showSnackbar({
        //         vertical: 'top',
        //         horizontal: 'right',
        //         message: 'Documentos diferentes. Por favor, selecione o mesmo documento.',
        //         variant: 'error',
        //     });
        // }
    };

    const updateFileDoc = (fileDoc) => {
        formData.fileDoc = fileDoc
    };

    const updateFilePdf = (filePdf) => {
        formData.filePdf = filePdf
    };

    const handleButtonClick = (event) => {
        const id = 'fileInput'+event.target.id;
        document.getElementById(id).click();
    };

    const handlesubmit = async (popupState, item) => {
        if( formData.fileDoc !== null && formData.filePdf !== null){
            const formDataToSend = new FormData();
            formDataToSend.append('fileDoc', formData.fileDoc);
            formDataToSend.append('filePdf', formData.filePdf);
            formDataToSend.append('login', localStorage.getItem('@gedy:user'));
            formDataToSend.append('item', JSON.stringify(item));
    
            try {
                showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Aguarde o upload dos arquivos.',
                    variant: 'info',
                });
                await AxiosInstance.post('/manipulate-documents/upload-review-document', formDataToSend, { headers: { "Content-Type": "multipart/form-data" } });
                await showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Upload feito com sucesso.',
                    variant: 'success',
                });
                await showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Aguarde agora aprovação do Revisão.',
                    variant: 'info',
                });
                GetData();
            } catch (error) {
                showSnackbar({
                    vertical: 'top',
                    horizontal: 'right',
                    message: 'Por favor, selecione os documentos que deseja enviar.',
                    variant: 'error',
                });
            }
        } else {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Por favor, selecione os documentos que deseja enviar.',
                variant: 'error',
            });
        }
    }

    const handleOpenDialog = (item, index) => {
        openDialog({ item, index });
    };

    const handleCloseDialog = () => {
        closeDialog();
    };

    const handleConfirmAction = () => {
        handleCloseDialog();
    };

    const handleCancelAction = () => {
        handleCloseDialog();
    };


    const renderDownloadIcon = (item, index) => {
        return (
            <IconButton
                aria-label="reprova"
                onClick={() => handleDownload(item, index)}
            >
                <DownloadingIcon fontSize="large" color="primary" />
            </IconButton>
        )
    };

    const renderEditIcon = (item, index) => {
        let disabledButton = false
        if(item.finished_review === false){
            disabledButton = true;
        }
        return(
            <IconButton
                aria-label="review"
                onClick={() => handleOpenDialog(item, index)}
            >
                <UpdateFileIcon 
                    fontSize="large" 
                    color={disabledButton ? "warning" : "primary"} />
            </IconButton>
        );
    };

    const renderUpdateIcon = (item,) => {
        const disabled = item.login === localStorage.getItem('@gedy:user') &&
            (item.upload === false ) ? false : true
        return item.finished_review === false ? (
            <PopupState variant="popover" popupId="button">
               {(popupState) =>
               <div>
                    <IconButton
                        aria-label="view"
                        disabled={disabled}
                        {...bindTrigger(popupState)}
                    >
                        <PublishIcon 
                            fontSize="large" 
                            color={disabled ? 'disabled' : 'warning'}
                        />
                    </IconButton>
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <Box m={2}>
                            <Grid container spacing={1}>
                                <Grid item>
                                    <input
                                        id="fileInputdocs"
                                        type="file"
                                        accept=""
                                        name="fileInputdocs"
                                        onChange={(e)=>handleFileChangeDocs(e, item)}
                                        style={{ display: 'none' }}
                                        required
                                    />
                                    <Button
                                        id="docs"
                                        variant='contained' 
                                        color='primary'
                                        onClick={handleButtonClick}
                                    >
                                        Upload do documento
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <input
                                        id="fileInputpdf"
                                        type="file"
                                        accept=".pdf"
                                        onChange={(e)=>handleFileChangePdf(e, item)}
                                        style={{ display: 'none' }}
                                        required
                                    />
                                    <Button
                                        id="pdf"
                                        variant='contained' 
                                        color='error' 
                                        onClick={handleButtonClick}
                                    >
                                        Upload do PDF
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        id="submit"
                                        variant='contained' 
                                        color='success' 
                                        onClick={()=> {
                                            handlesubmit(popupState, item)
                                            popupState.close();
                                        }}
                                    >
                                        Enviar
                                    </Button>
                                </Grid>                                                  
                            </Grid>
                        </Box>
                    </Popover>
                </div>
                }
            </PopupState>
        ) : (
            <>
            </>
        )
    };

    const extractRevision = (originalname) => {
        // Divide o nome do arquivo em partes com base em um espaço
        const parts = originalname.split(' ');
        // Procura por uma parte que contenha um "R" seguido de dois dígitos
        const revisionPart = parts.find(part => /R\d{2}/.test(part));
      
        if (revisionPart) {
            return revisionPart.slice(-3);
        }
        
        return 'R00';
    };


    const GetData = useCallback(async () => {
        const result = await AxiosInstance.get('/manipulate-documents/modify?login='+localStorage.getItem('@gedy:user'));
        const temp = await result?.data?.rows?.map((item, index) => ({
            ...item,
            revision: extractRevision(item.originalname),
            download: renderDownloadIcon(
                {
                    filename:item.filename,
                    type:item.document_type,
                    originalname:item.originalname
                }),
            editar: renderEditIcon(item, index),
            upload: renderUpdateIcon(item, index)
        }));
        setRows(temp);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        GetData();
    }, [GetData]);

    return (
        <Box p={1} component={Paper} elevation={3}>
            {isDialogOpen() && (
                <AlertDialogSlide
                    handleClose={handleCloseDialog}
                    handleConfirm={handleConfirmAction}
                    handleCancel={handleCancelAction}
                    dialogData={dialogData}
                />
            )}
            <Typography variant="h4" mb={1}>
                Revisar Documentos
            </Typography>
            <TableComponent
                columns={columns}
                rows={rows}
            />
        </Box>
    );
}

export default BodyValidationDocument;